// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"TQlIAHZPbqOF"};